import axios from "axios";
const API = 'https://gx92vct4sb.execute-api.us-west-2.amazonaws.com/prod/agents' 
export const fetchAllAgents = () => axios.get(API);